// @ts-strict-ignore
import * as React from 'react';

import { Playlist } from 'api';
import getImageFromSet from 'lib/get-image-from-set';

import Col from 'components/grid/col';
import PlaylistCard from 'components/playlist-card';
import { useSetSourceContext } from 'lib/business/source-context';

type PlaylistsGridItemProps = {
  playlist: Playlist;
};

function PlaylistsGridItem({
  playlist
}: PlaylistsGridItemProps): React.ReactNode {
  const imageUrl = getImageFromSet(playlist.primaryImageSet, '1x1');
  const setSourceContext = useSetSourceContext('content_discovery_context');

  return (
    <Col sm={2} md={3} lg={2}>
      <PlaylistCard
        className="mb-8"
        onClick={() => {
          setSourceContext('talks-related');
        }}
        href={`/playlists/${playlist.id}/${playlist.slug}`}
        imageUrl={imageUrl}
        title={playlist.title}
        author={playlist.author !== 'TED' && playlist.author}
        talksCount={playlist.videos.totalCount}
      />
    </Col>
  );
}

export default PlaylistsGridItem;
